import { createItem, readItems, updateItem } from "@directus/sdk";
import { getDirectusClient } from "../lib/directus";

const directus = getDirectusClient();
export const getInventarioNSPrestamos = async () => {
  try {
    const response = await directus.request(
      readItems("inventario_ns_prestamo", { fields: "*.*" })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const createInventarioNSPrestamo = async (data) => {
  try {
    const response = await directus.request(
      createItem("inventario_ns_prestamo", {
        ...data,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateInventarioNSPrestamo = async (id, data) => {
  try {
    const response = await directus.request(
      updateItem("inventario_ns_prestamo", id, {
        ...data,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getInventarioNSPrestamosByID = async (id) => {
  try {
    const response = await directus.request(
      readItems("inventario_ns_prestamo", {
        fields: [
          "inventario_ns.producto.preciosinimp",
          "inventario_ns.producto.grupo.impuesto",
          "cantidad",
          "id",
          "inventario_ns.nombre",
          "inventario_ns.id",
          "inventario_ns.producto.id",
          "estado",
          "date_created",
        
        ],
        filter: { inventario_ns: { id: { _eq: id } } },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getInventarioNSPrestamosByVendedor = async (vendedorId) => {
  try {
    const response = await directus.request(
      readItems("inventario_ns_prestamo", {
        fields: "*.*",
        filter: {
          _and: [
            {
              prestamos: {
                prestamos_id: {
                  vendedor: {
                    _eq: vendedorId,
                  },
                },
              },
            },
            {
              estado: "prestado",
            },
          ],
        },
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
